import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { IChangePassword, ILoginTokenUser, ISession, IUser } from '../models/index';
import { HttpService } from './http.service';
import { SHARED_API_CONFIG } from '../config/api.config';
import { FeedbackService } from './feedback.service';
import { LoginRequest } from '../models/login-request.model';
import { LoginRequestMapper } from '../mappers/login-request.mapper';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private _feedback = inject(FeedbackService);
  private _httpService = inject(HttpService);
  private _apiConfig = inject(SHARED_API_CONFIG);

  constructor() {}

  login(request: LoginRequest): Observable<ILoginTokenUser> {
    const loginRequest = this._httpService
      .post<ISession>(
        this._apiConfig.endpoints.login,
        LoginRequestMapper.toUserAdminLoginDto(request)
      )
      .pipe(
        map((response) => ({
          isCompleted: true,
          hash: '',
          session: response,
        }))
      );
    return loginRequest;
  }

  getProfileFromToken(): Observable<IUser> {
    return this._httpService.get<IUser>(this._apiConfig.endpoints.validateToken);
  }

  requestResetPasswordCode(_changePassword: Partial<IChangePassword>): Observable<void> {
    return this._httpService
      .post<{
        isSuccess: boolean;
        message: string;
      }>(this._apiConfig.endpoints.sendRecoveryCode, _changePassword)
      .pipe(map(() => void 0));
  }

  resetPassword(_changePassword: Partial<IChangePassword>): Observable<ILoginTokenUser> {
    const request = this._httpService
      .post<ISession>(this._apiConfig.endpoints.changePassword, _changePassword)
      .pipe(
        map((response) => ({
          isCompleted: true,
          hash: '',
          session: response,
        }))
      );
    return request;
  }

  verifyPassword(_password: string): Observable<boolean> {
    return this._httpService.post<boolean>(this._apiConfig.endpoints.verifyPassword, {
      password: _password,
    });
  }

  logout(): Observable<void> {
    // Logout is handled locally (JWT stateless). No server call needed.
    return of(void 0);
  }

  enableNotifications(_pushNotificationToken: string): Observable<void> {
    // TODO: Implement when enableNotifications endpoint is added to the API config.
    return of(void 0);
  }
}
